import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pos-controle-page"
  }, [_c('b-card', {
    staticClass: "mb-5 border-0 shadow-sm"
  }, [_c('div', {
    staticClass: "d-flex flex-wrap justify-content-between align-items-start"
  }, [_c('div', [_c('h3', {
    staticClass: "font-weight-bolder text-dark mb-2"
  }, [_vm._v(" Integração POS Controle ")]), _c('p', {
    staticClass: "text-muted mb-0"
  }, [_vm._v(" Envie o catálogo para o PDV Mobi e acompanhe as vendas realizadas nos terminais. ")])]), _c('div', {
    staticClass: "d-flex align-items-center mt-2 mt-md-0"
  }, [_c('span', {
    staticClass: "badge mr-3",
    class: _vm.statusConexaoClass
  }, [_vm._v(" " + _vm._s(_vm.statusConexaoLabel) + " ")]), _c('router-link', {
    staticClass: "btn btn-light",
    attrs: {
      "to": {
        name: 'posLista'
      }
    }
  }, [_vm._v(" Voltar aos terminais ")])], 1)])]), _c('b-card', {
    staticClass: "border-0 shadow-sm"
  }, [_c('b-tabs', {
    staticClass: "pos-controle-tabs",
    attrs: {
      "pills": "",
      "card": "",
      "fill": "",
      "nav-class": "pos-controle-tabs-nav"
    },
    on: {
      "input": _vm.alterarAba
    },
    model: {
      value: _vm.abaAtiva,
      callback: function callback($$v) {
        _vm.abaAtiva = $$v;
      },
      expression: "abaAtiva"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Conexão"
    }
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.carregandoConfiguracao,
      "rounded": "sm"
    }
  }, [_c('b-alert', {
    staticClass: "border mb-5",
    attrs: {
      "show": "",
      "variant": "light"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap justify-content-between"
  }, [_c('div', [_c('strong', [_vm._v("Credenciais:")]), _vm._v(" " + _vm._s(_vm.origemCredenciaisLabel) + " ")]), _vm.integracao.ultima_tentativa_em ? _c('div', [_c('strong', [_vm._v("Última tentativa:")]), _vm._v(" " + _vm._s(_vm.formatarData(_vm.integracao.ultima_tentativa_em)) + " ")]) : _vm._e()]), _vm.integracao.ultimo_erro ? _c('div', {
    staticClass: "text-danger mt-2"
  }, [_vm._v(" " + _vm._s(_vm.integracao.ultimo_erro) + " ")]) : _vm._e()]), _c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.salvarConfiguracao.apply(null, arguments);
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Usuário da API",
      "label-for": "pos-controle-usuario",
      "description": "Preencha apenas para cadastrar ou alterar o usuário. Deixe vazio para manter o salvo."
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "pos-controle-usuario",
      "maxlength": "255",
      "autocomplete": "off"
    },
    model: {
      value: _vm.configForm.username,
      callback: function callback($$v) {
        _vm.$set(_vm.configForm, "username", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "configForm.username"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Senha da API",
      "label-for": "pos-controle-senha",
      "description": _vm.descricaoSenha
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "id": "pos-controle-senha",
      "type": _vm.mostrarSenha ? 'text' : 'password',
      "maxlength": "255",
      "autocomplete": "new-password"
    },
    model: {
      value: _vm.configForm.password,
      callback: function callback($$v) {
        _vm.$set(_vm.configForm, "password", $$v);
      },
      expression: "configForm.password"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "type": "button",
      "variant": "outline-secondary",
      "title": _vm.mostrarSenha ? 'Ocultar senha' : 'Mostrar senha',
      "aria-label": _vm.mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'
    },
    on: {
      "click": function click($event) {
        _vm.mostrarSenha = !_vm.mostrarSenha;
      }
    }
  }, [_c('i', {
    class: _vm.mostrarSenha ? 'fas fa-eye-slash' : 'fas fa-eye',
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.possuiChaveOcp ? 'CHAVE OCP' : 'CHAVE OCP *',
      "label-for": "pos-controle-chave-ocp",
      "description": _vm.descricaoChaveOcp
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "id": "pos-controle-chave-ocp",
      "type": _vm.mostrarChaveOcp ? 'text' : 'password',
      "required": !_vm.possuiChaveOcp,
      "maxlength": "255",
      "autocomplete": "new-password"
    },
    model: {
      value: _vm.configForm.chave_ocp,
      callback: function callback($$v) {
        _vm.$set(_vm.configForm, "chave_ocp", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "configForm.chave_ocp"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "type": "button",
      "variant": "outline-secondary",
      "title": _vm.mostrarChaveOcp ? 'Ocultar CHAVE OCP' : 'Mostrar CHAVE OCP',
      "aria-label": _vm.mostrarChaveOcp ? 'Ocultar CHAVE OCP' : 'Mostrar CHAVE OCP'
    },
    on: {
      "click": function click($event) {
        _vm.mostrarChaveOcp = !_vm.mostrarChaveOcp;
      }
    }
  }, [_c('i', {
    class: _vm.mostrarChaveOcp ? 'fas fa-eye-slash' : 'fas fa-eye',
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)], 1)], 1)], 1)], 1), _c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', {
    attrs: {
      "md": "3",
      "sm": "6"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.configForm.ativo,
      callback: function callback($$v) {
        _vm.$set(_vm.configForm, "ativo", $$v);
      },
      expression: "configForm.ativo"
    }
  }, [_vm._v(" Integração ativa ")])], 1), _c('b-col', {
    attrs: {
      "md": "3",
      "sm": "6"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.configForm.sincronizar_grupos,
      callback: function callback($$v) {
        _vm.$set(_vm.configForm, "sincronizar_grupos", $$v);
      },
      expression: "configForm.sincronizar_grupos"
    }
  }, [_vm._v(" Atualizar grupos automaticamente ")])], 1), _c('b-col', {
    attrs: {
      "md": "3",
      "sm": "6"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.configForm.sincronizar_produtos,
      callback: function callback($$v) {
        _vm.$set(_vm.configForm, "sincronizar_produtos", $$v);
      },
      expression: "configForm.sincronizar_produtos"
    }
  }, [_vm._v(" Atualizar produtos automaticamente ")])], 1), _c('b-col', {
    attrs: {
      "md": "3",
      "sm": "6"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.configForm.sincronizar_vendas,
      callback: function callback($$v) {
        _vm.$set(_vm.configForm, "sincronizar_vendas", $$v);
      },
      expression: "configForm.sincronizar_vendas"
    }
  }, [_vm._v(" Buscar vendas automaticamente ")])], 1)], 1), _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.configForm.emitir_nfce_automaticamente,
      callback: function callback($$v) {
        _vm.$set(_vm.configForm, "emitir_nfce_automaticamente", $$v);
      },
      expression: "configForm.emitir_nfce_automaticamente"
    }
  }, [_vm._v(" Emitir NFC-e automaticamente ")]), _c('small', {
    staticClass: "d-block text-muted mt-1"
  }, [_vm._v(" A cada 10 minutos, emite as pré-vendas importadas do POS Controle usando a configuração padrão de NFC-e do PDV Web. Vendas com falhas nos dados fiscais aguardam correção. ")])], 1)], 1), _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.configForm.movimentar_estoque,
      callback: function callback($$v) {
        _vm.$set(_vm.configForm, "movimentar_estoque", $$v);
      },
      expression: "configForm.movimentar_estoque"
    }
  }, [_vm._v(" Baixar estoque ao importar as vendas ")]), _c('small', {
    staticClass: "d-block text-muted mt-1"
  }, [_vm._v(" Usa o ProductID para fazer o vinculo. ")])], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.configForm.gerar_financeiro,
      callback: function callback($$v) {
        _vm.$set(_vm.configForm, "gerar_financeiro", $$v);
      },
      expression: "configForm.gerar_financeiro"
    }
  }, [_vm._v(" Gerar financeiro conforme o pagamento ")]), _c('small', {
    staticClass: "d-block text-muted mt-1"
  }, [_vm._v(" Dinheiro, PIX, débito, crédito e parcelas são associados às formas de pagamento cadastradas. ")])], 1)], 1), _c('div', {
    staticClass: "d-flex flex-wrap justify-content-end mt-6"
  }, [_c('b-button', {
    staticClass: "mr-2 mb-2",
    attrs: {
      "type": "button",
      "variant": "outline-primary",
      "disabled": _vm.testandoConexao || _vm.salvandoConfiguracao
    },
    on: {
      "click": _vm.testarConexao
    }
  }, [_vm.testandoConexao ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Testar conexão ")], 1), _c('b-button', {
    staticClass: "mb-2",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.salvandoConfiguracao || _vm.testandoConexao
    }
  }, [_vm.salvandoConfiguracao ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.configuracaoBotaoLabel) + " ")], 1)], 1)], 1), _c('div', {
    staticClass: "border rounded p-5 mt-6 bg-light"
  }, [_c('div', {
    staticClass: "d-flex flex-wrap justify-content-between align-items-center"
  }, [_c('div', {
    staticClass: "pr-md-5"
  }, [_c('h5', {
    staticClass: "font-weight-bolder mb-2"
  }, [_vm._v("Implantação inicial")]), _c('p', {
    staticClass: "text-muted mb-0"
  }, [_vm._v(" Para uma base nova, importe os grupos, produtos e todas as vendas do primeiro dia do mês até agora. ")])]), _c('b-button', {
    staticClass: "mt-3 mt-md-0",
    attrs: {
      "variant": "success",
      "disabled": _vm.importandoBase || _vm.salvandoConfiguracao || !_vm.configurado || !_vm.configForm.ativo
    },
    on: {
      "click": _vm.confirmarImportacaoInicial
    }
  }, [_vm.importandoBase ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Importar base do POS ")], 1)], 1), _vm.importacaoInicialResultado ? _c('b-alert', {
    staticClass: "mt-4 mb-0",
    attrs: {
      "show": "",
      "variant": _vm.importacaoInicialVariant
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.importacaoInicialMensagem))]), _vm.importacaoInicialErros.length ? _c('ul', {
    staticClass: "mb-0 mt-2"
  }, _vm._l(_vm.importacaoInicialErros, function (erro, index) {
    return _c('li', {
      key: 'importacao-' + index
    }, [_vm._v(" " + _vm._s(erro) + " ")]);
  }), 0) : _vm._e()]) : _vm._e()], 1)], 1)], 1), _c('b-tab', {
    attrs: {
      "title": "Catálogo",
      "lazy": ""
    }
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.carregandoCatalogo || _vm.sincronizandoCatalogo || _vm.baixandoCatalogo,
      "rounded": "sm"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap justify-content-between align-items-center mb-5"
  }, [_c('div', [_c('h5', {
    staticClass: "font-weight-bolder mb-1"
  }, [_vm._v("Grupos e produtos")]), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(" Envie o catálogo do Nuts ou baixe alterações feitas no POS Controle. ")])]), _c('div', {
    staticClass: "mt-3 mt-md-0"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "outline-secondary",
      "disabled": _vm.carregandoCatalogo || _vm.baixandoCatalogo
    },
    on: {
      "click": _vm.carregarCatalogo
    }
  }, [_vm._v(" Atualizar lista ")]), _c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "outline-primary",
      "disabled": _vm.sincronizandoCatalogo || _vm.baixandoCatalogo
    },
    on: {
      "click": _vm.baixarAlteracoesCatalogo
    }
  }, [_vm._v(" Baixar alterações do POS ")]), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.sincronizandoCatalogo || _vm.baixandoCatalogo
    },
    on: {
      "click": _vm.sincronizarTudo
    }
  }, [_vm._v(" Sincronizar tudo ")])], 1)]), _vm.catalogoResultado ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": _vm.catalogoResultadoVariant
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.catalogoResultadoMensagem))]), _vm.catalogoErros.length ? _c('ul', {
    staticClass: "mb-0 mt-2"
  }, _vm._l(_vm.catalogoErros, function (erro, index) {
    return _c('li', {
      key: index
    }, [_vm._v(" " + _vm._s(erro) + " ")]);
  }), 0) : _vm._e()]) : _vm._e(), _vm.catalogoDownloadResultado ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": _vm.catalogoDownloadVariant
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.catalogoDownloadMensagem))]), _vm.catalogoDownloadErros.length ? _c('ul', {
    staticClass: "mb-0 mt-2"
  }, _vm._l(_vm.catalogoDownloadErros, function (erro, index) {
    return _c('li', {
      key: 'download-' + index
    }, [_vm._v(" " + _vm._s(erro) + " ")]);
  }), 0) : _vm._e()]) : _vm._e(), _c('b-row', [_c('b-col', {
    staticClass: "mb-5 mb-lg-0",
    attrs: {
      "lg": "5"
    }
  }, [_c('div', {
    staticClass: "catalogo-panel border rounded"
  }, [_c('div', {
    staticClass: "p-4 border-bottom"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-3"
  }, [_c('strong', [_vm._v("Grupos")]), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.gruposSelecionados.length) + " selecionado(s)")])]), _c('b-form-input', {
    attrs: {
      "placeholder": "Pesquisar grupo",
      "size": "sm"
    },
    model: {
      value: _vm.buscaGrupo,
      callback: function callback($$v) {
        _vm.buscaGrupo = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "buscaGrupo"
    }
  }), _c('b-form-checkbox', {
    staticClass: "mt-3",
    attrs: {
      "checked": _vm.todosGruposVisiveisSelecionados
    },
    on: {
      "change": _vm.selecionarGruposVisiveis
    }
  }, [_vm._v(" Selecionar os grupos exibidos ")])], 1), _c('div', {
    staticClass: "catalogo-lista"
  }, [_vm._l(_vm.gruposFiltrados, function (grupo) {
    return _c('label', {
      key: grupo.id,
      staticClass: "catalogo-item"
    }, [_c('b-form-checkbox', {
      attrs: {
        "value": grupo.id
      },
      model: {
        value: _vm.gruposSelecionados,
        callback: function callback($$v) {
          _vm.gruposSelecionados = $$v;
        },
        expression: "gruposSelecionados"
      }
    }), grupo.imagem ? _c('img', {
      staticClass: "catalogo-thumb",
      attrs: {
        "src": grupo.imagem,
        "alt": grupo.nome
      }
    }) : _vm._e(), _c('span', {
      staticClass: "ml-2"
    }, [_c('strong', [_vm._v(_vm._s(grupo.nome))]), _c('small', {
      staticClass: "d-block text-muted"
    }, [_vm._v(" A descrição será adaptada automaticamente para o POS ")])])], 1);
  }), !_vm.gruposFiltrados.length ? _c('div', {
    staticClass: "empty-list"
  }, [_vm._v(" Nenhum grupo encontrado. ")]) : _vm._e()], 2)])]), _c('b-col', {
    attrs: {
      "lg": "7"
    }
  }, [_c('div', {
    staticClass: "catalogo-panel border rounded"
  }, [_c('div', {
    staticClass: "p-4 border-bottom"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-3"
  }, [_c('strong', [_vm._v("Produtos ativos")]), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(" " + _vm._s(_vm.produtosSelecionados.length) + " selecionado(s) · exibindo " + _vm._s(_vm.produtosFiltrados.length) + " de " + _vm._s(_vm.totalProdutosFiltrados) + " ")])]), _c('b-form-input', {
    attrs: {
      "placeholder": "Pesquisar por código ou descrição",
      "size": "sm"
    },
    model: {
      value: _vm.buscaProduto,
      callback: function callback($$v) {
        _vm.buscaProduto = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "buscaProduto"
    }
  }), _c('b-form-checkbox', {
    staticClass: "mt-3",
    attrs: {
      "checked": _vm.todosProdutosVisiveisSelecionados
    },
    on: {
      "change": _vm.selecionarProdutosVisiveis
    }
  }, [_vm._v(" Selecionar os produtos exibidos ")])], 1), _c('div', {
    staticClass: "catalogo-lista"
  }, [_vm._l(_vm.produtosFiltrados, function (produto) {
    return _c('label', {
      key: produto.id,
      staticClass: "catalogo-item"
    }, [_c('b-form-checkbox', {
      attrs: {
        "value": produto.id
      },
      model: {
        value: _vm.produtosSelecionados,
        callback: function callback($$v) {
          _vm.produtosSelecionados = $$v;
        },
        expression: "produtosSelecionados"
      }
    }), produto.imagem ? _c('img', {
      staticClass: "catalogo-thumb",
      attrs: {
        "src": produto.imagem,
        "alt": produto.descricao
      }
    }) : _vm._e(), _c('span', {
      staticClass: "ml-2 flex-grow-1"
    }, [_c('strong', [_vm._v(_vm._s(produto.codigo) + " · " + _vm._s(produto.descricao))]), _c('small', {
      staticClass: "d-block text-muted"
    }, [_vm._v(" " + _vm._s(produto.grupo || "Sem grupo") + " · " + _vm._s(_vm.formatarMoeda(produto.preco)) + " ")])])], 1);
  }), !_vm.produtosFiltrados.length ? _c('div', {
    staticClass: "empty-list"
  }, [_vm._v(" Nenhum produto encontrado. ")]) : _vm._e()], 2)])])], 1), _c('div', {
    staticClass: "d-flex justify-content-end mt-5"
  }, [_c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": !_vm.possuiSelecaoCatalogo || _vm.sincronizandoCatalogo
    },
    on: {
      "click": _vm.sincronizarSelecionados
    }
  }, [_vm._v(" Sincronizar selecionados ")])], 1)], 1)], 1), _c('b-tab', {
    attrs: {
      "title": "Vendas",
      "lazy": ""
    }
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.carregandoVendas || _vm.sincronizandoVendas,
      "rounded": "sm"
    }
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.aplicarFiltrosVendas.apply(null, arguments);
      }
    }
  }, [_c('b-row', {
    attrs: {
      "align-v": "end"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data inicial"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.filtrosVendas.data_inicial,
      callback: function callback($$v) {
        _vm.$set(_vm.filtrosVendas, "data_inicial", $$v);
      },
      expression: "filtrosVendas.data_inicial"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data final"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.filtrosVendas.data_final,
      callback: function callback($$v) {
        _vm.$set(_vm.filtrosVendas, "data_final", $$v);
      },
      expression: "filtrosVendas.data_final"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Situação no POS"
    }
  }, [_c('b-form-select', {
    model: {
      value: _vm.filtrosVendas.status_remoto,
      callback: function callback($$v) {
        _vm.$set(_vm.filtrosVendas, "status_remoto", $$v);
      },
      expression: "filtrosVendas.status_remoto"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todas")]), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Concluída")]), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Cancelada")])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Terminal"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Número serial"
    },
    model: {
      value: _vm.filtrosVendas.serial_number,
      callback: function callback($$v) {
        _vm.$set(_vm.filtrosVendas, "serial_number", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "filtrosVendas.serial_number"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Busca"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Venda, NF ou cliente"
    },
    model: {
      value: _vm.filtrosVendas.busca,
      callback: function callback($$v) {
        _vm.$set(_vm.filtrosVendas, "busca", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "filtrosVendas.busca"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "mb-5",
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary",
      "block": ""
    }
  }, [_vm._v(" Filtrar ")])], 1)], 1)], 1), _c('div', {
    staticClass: "d-flex flex-wrap justify-content-between align-items-center mb-4"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.paginacaoVendas.total) + " venda(s) importada(s)")]), _c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": _vm.sincronizandoVendas
    },
    on: {
      "click": _vm.sincronizarPeriodoVendas
    }
  }, [_vm.sincronizandoVendas ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Buscar novas vendas no POS ")], 1)], 1), _vm.vendasResultado ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": _vm.vendasResultadoVariant
    }
  }, [_vm._v(" " + _vm._s(_vm.vendasResultadoMensagem) + " ")]) : _vm._e(), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover align-middle"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Data")]), _c('th', [_vm._v("Venda")]), _c('th', [_vm._v("Terminal")]), _c('th', [_vm._v("NF")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Total")]), _c('th', [_vm._v("Status")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Ações")])])]), _c('tbody', [_vm._l(_vm.vendas, function (venda) {
    return _c('tr', {
      key: venda.id
    }, [_c('td', [_vm._v(_vm._s(_vm.formatarData(venda.vendida_em)))]), _c('td', [_c('strong', [_vm._v(_vm._s(venda.sale_pos_code_id || venda.sale_id))]), _vm.documentoClienteVenda(venda) ? _c('small', {
      staticClass: "d-block text-muted"
    }, [_vm._v(" Cliente: " + _vm._s(_vm.documentoClienteVenda(venda)) + " ")]) : _vm._e(), venda.id_nfe ? _c('small', {
      staticClass: "d-block text-success"
    }, [_vm._v(" Documento Nuts #" + _vm._s(venda.id_nfe) + " ")]) : _vm._e()]), _c('td', [_vm._v(_vm._s(venda.serial_number || "—"))]), _c('td', [_vm._v(_vm._s(venda.numero_nf || "—"))]), _c('td', {
      staticClass: "text-right font-weight-bold"
    }, [_vm._v(" " + _vm._s(_vm.formatarMoeda(venda.valor_total)) + " ")]), _c('td', [_c('span', {
      staticClass: "badge",
      class: _vm.statusVendaClass(venda)
    }, [_vm._v(" " + _vm._s(_vm.statusVendaLabel(venda)) + " ")]), venda.ultimo_erro_nfce ? _c('small', {
      staticClass: "d-block text-danger mt-1"
    }, [_vm._v(" NFC-e: " + _vm._s(venda.ultimo_erro_nfce) + " ")]) : _vm._e()]), _c('td', {
      staticClass: "text-right"
    }, [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-primary"
      },
      on: {
        "click": function click($event) {
          return _vm.abrirDetalheVenda(venda.id);
        }
      }
    }, [_vm._v(" Detalhes ")])], 1)]);
  }), !_vm.vendas.length ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted py-8",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v(" Nenhuma venda encontrada. Use “Buscar novas vendas no POS” para importar. ")])]) : _vm._e()], 2)])]), _vm.paginacaoVendas.total > _vm.paginacaoVendas.per_page ? _c('b-pagination', {
    attrs: {
      "total-rows": _vm.paginacaoVendas.total,
      "per-page": _vm.paginacaoVendas.per_page,
      "align": "right"
    },
    on: {
      "change": _vm.mudarPaginaVendas
    },
    model: {
      value: _vm.paginaVendas,
      callback: function callback($$v) {
        _vm.paginaVendas = $$v;
      },
      expression: "paginaVendas"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "pos-controle-venda-detalhe",
      "size": "xl",
      "title": "Detalhes da venda no POS",
      "hide-footer": ""
    }
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.carregandoDetalhe,
      "rounded": "sm"
    }
  }, [_vm.vendaDetalhe ? _c('div', [_c('b-row', {
    staticClass: "mb-5"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Venda:")]), _c('br'), _vm._v(_vm._s(_vm.vendaDetalhe.sale_id))]), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Data:")]), _c('br'), _vm._v(_vm._s(_vm.formatarData(_vm.vendaDetalhe.vendida_em)))]), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Terminal:")]), _c('br'), _vm._v(_vm._s(_vm.vendaDetalhe.serial_number || "—"))]), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Total:")]), _c('br'), _vm._v(_vm._s(_vm.formatarMoeda(_vm.vendaDetalhe.valor_total)))])], 1), _vm.vendaDetalhe.ultimo_erro_nfce ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(" Falha na emissão automática de NFC-e: " + _vm._s(_vm.vendaDetalhe.ultimo_erro_nfce) + " ")]) : _vm._e(), _vm.vendaDetalhe.ultima_tentativa_nfce_em ? _c('p', {
    staticClass: "text-muted"
  }, [_vm._v(" Última tentativa de emissão automática: " + _vm._s(_vm.formatarData(_vm.vendaDetalhe.ultima_tentativa_nfce_em)) + " ")]) : _vm._e(), _c('h6', {
    staticClass: "font-weight-bolder"
  }, [_vm._v("Itens")]), _c('div', {
    staticClass: "table-responsive mb-5"
  }, [_c('table', {
    staticClass: "table table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Produto")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Qtd.")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Unitário")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Total")])])]), _c('tbody', [_vm._l(_vm.itensVendaDetalhe, function (item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(_vm.nomeItemVenda(item)))]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(item.Quantity || item.quantity || "—") + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.formatarMoeda(item.UnitPrice || item.PriceAmount || 0)) + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.formatarMoeda(item.AmntTotal || _vm.totalItemVenda(item))) + " ")])]);
  }), !_vm.itensVendaDetalhe.length ? _c('tr', [_c('td', {
    staticClass: "text-muted text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(" A API não retornou os itens desta venda. ")])]) : _vm._e()], 2)])]), _c('h6', {
    staticClass: "font-weight-bolder"
  }, [_vm._v("Pagamentos")]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Forma")]), _c('th', [_vm._v("Autorização")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Valor")])])]), _c('tbody', [_vm._l(_vm.pagamentosVendaDetalhe, function (pagamento, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(" " + _vm._s(pagamento.PaymentTypeName || pagamento.Name || pagamento.PaymentType || "—") + " ")]), _c('td', [_vm._v(" " + _vm._s(pagamento.AuthorizationCode || pagamento.Authorization || "—") + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.formatarMoeda(pagamento.PaidAmount || pagamento.Amount || 0)) + " ")])]);
  }), !_vm.pagamentosVendaDetalhe.length ? _c('tr', [_c('td', {
    staticClass: "text-muted text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(" A API não retornou os pagamentos desta venda. ")])]) : _vm._e()], 2)])])], 1) : _vm._e()])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };